import React from "react";

import mapPin from "/asset/svg/location-filled.svg";

import { Link, MapImage, MarkerImage } from "./Map.styles";
import { Props } from "./Map.types";

/**
 * The Map component renders a static map image using AWS API. Pressing
 * the map will open a Google Maps link in a new tab. The `center` prop
 * determines the location rendered by the map, and a marker will be placed at
 * the address given.
 */
export const Map = ({
  alt = "Map",
  center_lng,
  center_lat,
  className,
  height = 160,
  width = 640,
  zoom = 16,
  link,
  ...otherProps
}: Props): JSX.Element => (
  <Link
    $height={height}
    $width={width}
    className={className}
    href={
      link ? link : `https://www.google.com/maps/search/?api=1&query=${center_lat},${center_lng}`
    }
    rel="noopener noreferrer"
    target="_blank"
  >
    {center_lng && center_lat && (
      <MapImage
        alt={alt}
        src={`${process.env.AWS_STATIC_MAP_URL}/static/map?style=Standard&center=${center_lng},${center_lat}&zoom=${zoom}&width=${width}&height=${height}&key=${process.env.AWS_LOCATION_SERVICE_TOKEN}`}
        {...otherProps}
      />
    )}
    <MarkerImage aria-hidden src={mapPin} />
  </Link>
);

export default Map;
